import React from 'react';

import { TextArea as RadixTextArea } from '@radix-ui/themes';
import classNames from 'classnames';

import { Text } from '../Text';
import { Tooltip } from '../Tooltip';
import styles from './TextArea.module.less';
import {
  TextAreaProps,
  sizeToClassName,
  sizeToFontSize,
} from './TextArea.types';

function TextArea({
  label,
  error,
  errorMessage,
  required,
  size = '2',

  tooltip,
  withTooltip = true,

  className,
  ref,
  ...props
}: TextAreaProps & { ref?: React.Ref<HTMLTextAreaElement> }) {
  const hasError = !!error || !!errorMessage;

  const textAreaField = (
    <RadixTextArea
      {...props}
      ref={ref}
      size={size}
      className={classNames(
        className,
        sizeToFontSize[size],
        sizeToClassName[size],
        styles.textField,
        hasError && styles.error
      )}
    />
  );

  const content = withTooltip ? (
    <Tooltip open={tooltip ? undefined : false} side='bottom' content={tooltip}>
      {textAreaField}
    </Tooltip>
  ) : (
    textAreaField
  );

  return label ? (
    <label
      className={classNames(sizeToFontSize[size], 'flex flex-col gap-fly-4')}
    >
      <Text size='2' highContrast weight='bold'>
        {label}
        {required && '*'}
      </Text>
      {content}
      {!!errorMessage && (
        <Text size='2' color='red'>
          {errorMessage}
        </Text>
      )}
    </label>
  ) : (
    content
  );
}

export { TextArea };
